import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#F7F4EE] px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#FDFBF7] p-10">
        <Link to="/" className="text-[13px] tracking-[0.42em]">LASZLO ABONYI</Link>
        <h1 className="mt-10 font-display text-4xl font-light">Studio sign in</h1>
        <label className="mt-10 block">
          <span className="field-label">Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" data-testid="admin-login-email" />
        </label>
        <label className="mt-8 block">
          <span className="field-label">Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field" data-testid="admin-login-password" />
        </label>
        {error && <p className="mt-6 text-sm text-[#8B2E24]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary mt-10 w-full" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
